const server_configuration = {
  "localdevelopment": {
    "address": "http://localhost:3001",
    "computablepublishing_website_address": "http://localhost:3001",
    "computable_publishing_node_server_address": "http://localhost:3106/",
    "fevir_website_address": "http://localhost:3000",
    "fevir_node_server_address": "http://localhost:3104/",
    "fevir_websocket_address": "ws://localhost:3104/ws",
    "fevir_go_server_address": "http://localhost:3107/",
    "ports": {
      "master_server": 3024,
      "fevir_master_server": 3104
    }
  },
  "localdevelopmentbutwithproductiondatabase": {
    "address": "https://fevir.net",
    "computablepublishing_website_address": "http://localhost:3001",
    "computable_publishing_node_server_address": "http://localhost:3106/",
    "fevir_website_address": "http://localhost:3000",
    "fevir_node_server_address": "http://localhost:3004/",
    "fevir_websocket_address": "ws://localhost:3004/ws",
    "fevir_go_server_address": "http://localhost:3107/",
    "ports": {
      "master_server": 3024,
      "fevir_master_server": 3004
    }
  },
  "development": {
    "address": "https://dev.fevir.net",
    "computablepublishing_website_address": "https://computablepublishing.com",
    "computable_publishing_node_server_address": "https://dev.fevir.net/computablepublishingnodeserver/",
    "fevir_website_address": "https://dev.fevir.net",   //"http://localhost:3000",     //If you want to login on local
    "fevir_node_server_address": "https://dev.fevir.net/nodeserver/",
    "fevir_websocket_address": "wss://ws.dev.fevir.net/",
    "fevir_go_server_address": "https://dev.fevir.net/goserver/"
  },
  "production": {
    "address": "https://fevir.net",
    "computablepublishing_website_address": "https://computablepublishing.com",
    "computable_publishing_node_server_address": "https://fevir.net/computablepublishingnodeserver/",
    "fevir_website_address": "https://fevir.net",
    "fevir_node_server_address": "https://fevir.net/nodeserver/",
    "fevir_websocket_address": "wss://ws.fevir.net/",
    "fevir_go_server_address": "https://fevir.net/goserver/"
  }
};
let server_config;
if (window.location.hostname === "fevir.net" || window.location.hostname === "computablepublishing.com") {
  server_config = server_configuration["production"];
} else if (window.location.hostname === "dev.fevir.net") {
  server_config = server_configuration["development"];
} else {
  server_config = server_configuration["development"]; //production //development //localdevelopment //localdevelopmentbutwithproductiondatabase
}
export default server_config;